import { useQuery } from 'react-query';
import { authFetch } from '../../CommonUtils/authFetch';
import { urlWithParams } from '../../CommonUtils/urlWithParams';
import { QueryFeature } from '../../../config/queryClient';

interface PositionsDTO {
  costBasis: number | null;
  costPerShare: number;
  marketValue: number;
  price: number;
  units: number;
  unrealized: number | null;
  holdingPeriod: string;
  purchaseDate: string;
}

export const POSITIONS_UNREALIZED_DETAILS_QUERY_KEY = 'positionsUnrealizedDetails';

interface FetchPositionsUnrealizedDetailsParams {
  clientId: string;
  orionPositionName: string;
  accountId?: string;
  groupId?: string;
}

const fetchPositionsUnrealizedDetails = async ({
  clientId,
  orionPositionName,
  accountId,
  groupId,
}: FetchPositionsUnrealizedDetailsParams): Promise<PositionsDTO[]> =>
  authFetch(
    urlWithParams(
      '/Consumer/OrionAccountsWidgets/PositionUnrealizedLotDetails',
      {
        clientId,
        accountId: accountId || null,
        groupId: groupId || null,
        orionPositionName,
      },
      { skipNulls: true },
    ),
  );

interface PositionsUnrealizedDetailsQueryParams {
  clientId: string;
  accountId?: string;
  orionPositionName: string;
  groupId?: string;
}

export const usePositionsUnrealizedDetailsQuery = ({
  clientId,
  accountId,
  orionPositionName,
  groupId,
}: PositionsUnrealizedDetailsQueryParams) => {
  return useQuery(
    [
      QueryFeature.AccountPerformanceReporting,
      POSITIONS_UNREALIZED_DETAILS_QUERY_KEY,
      clientId,
      orionPositionName,
      accountId,
      groupId,
    ],

    () => fetchPositionsUnrealizedDetails({ clientId, orionPositionName, accountId, groupId }),

    { enabled: !!orionPositionName },
  );
};
